<template>
  <div id="app">
    <v-app>
      <Header
        v-if="$route.meta.header"
        :title="$route.meta.pageTitle"
        :arrow_forward="$route.meta.arrow_forward"
        :iconDrawer="$route.meta.iconDrawer"
        :titles="$route.meta.titles"
        :backPage="$route.meta.backPage"
        :store="$route.meta.store"
        :search="$route.meta.search"
      />
      <router-view />
    </v-app>
  </div>
</template>

<script>
import Vue from "vue";
import Header from "@/components/Header/Header";
import oracle from "@/oracle";
import { dev_mode } from "./oracle";

Vue.mixin({
  methods: {
    print(data) {
      if (dev_mode) {
        console.log(data);
      }
    },
  },
});

export default {
  name: "App",
  components: {
    Header,
  },
  mounted() {
    let path = window.location.pathname;
    let page = path.split("/").pop();
    if (oracle.getToken() == null) {
      if (page == "register") {
        return;
      }
      this.$router.push("register");
    } else if (page == "register") {
      this.$router.push("home");
    }
  },
};
</script>

<style>
@font-face {
  font-family: "IranianSans";
  src: url("./assets/fonts/new/IranianSansRegular.ttf") format("truetype"),
    url("./assets/fonts/new/IRANSans-web.woff") format("woff");
  font-weight: normal;
  font-style: normal;
}

* {
  font-family: "IranianSans";
}

body {
  direction: rtl;
  background-color: #f9f9fb !important;
  letter-spacing: inherit;
}

.v-application--wrap {
  background-color: #f9f9fb !important;
}

*:focus {
  box-shadow: none !important;
  border: none !important;
  outline: none !important;
}

button:focus,
input:focus,
textarea:focus {
  box-shadow: none !important;
  border: none !important;
  outline: none !important;
}

a:hover {
  text-decoration: none !important;
}

a {
  text-decoration: none !important;
}

ul,
ol {
  margin: 0 !important;
  padding: 0;
  list-style: none;
}

.v-application--wrap {
  min-height: unset !important;
  height: 100vh !important;
}

.confirm-box-Wapper {
  background-color: #f9f9fc;
  height: 92%;
  overflow: scroll;
  padding: 16px;
  color: #707070;
  font-weight: bold;
  font-size: 15px;
}
::-webkit-scrollbar-button {
  display: none;
}
::-webkit-scrollbar {
  width: 5px;
}
::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background: #20bf6b;
}
</style>
